import React, { useState } from "react";
import PropTypes from "prop-types";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import {
  Autoplay,
  Pagination,
  Navigation,
  Mousewheel,
  Keyboard,
} from "swiper/modules";
import "swiper/css";
import Testimonial from "../instances/Testimonial";
import SectionNumber from "../global/SectionNumber";
import SmartColour from "../../utils/ColourHandler";
import SmartText from "../../utils/TextHandler";
import SmartStyles from "../../utils/StyleHandler";
import Progress from "../global/Progress";

/********************************
<Testimonials />
/********************************
Version: 1.2
Created: 24 08 2023
Updated: 19 02 2025
Author: Richy Pears
/********************************
Displays testimonials in a carousel

TODO: Make accessible
/********************************/

const Testimonials = ({ blok }) => {
  const [activeIndex, setActiveIndex] = useState(1);

  if (!blok) return null; // Escape hatch

  const { copy, items, number, padding, rounded, subtitle, theme, title } =
    blok;

  const colour = SmartColour(theme);

  const randomId =
    "brand_controller_wrapper_testimonials_" +
    Math.floor(Math.random() * 100) +
    1; // Random string created for unique ID

  return (
    <section
      className={`flex flex-col ${
        colour.classes && colour.classes
      } ${SmartStyles("padding", padding)} ${SmartStyles("rounded", rounded)}`}
      id={randomId}
    >
      <div className="brand-container flex flex-col gap-10 md:gap-12 mb-10 md:mb-12">
        <SectionNumber title={subtitle && subtitle} number={number && number} />
        {copy?.content[0]?.content && (
          <SmartText className="m-0 text-center brand-remove-last-margin">
            {copy}
          </SmartText>
        )}
        <div className={`brand-controller-wrapper`}>
          <Swiper
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            centeredSlides={true}
            className="w-full"
            loop={false}
            modules={[Autoplay, Pagination, Navigation, Mousewheel, Keyboard]}
            navigation={{
              prevEl: `#${randomId} .brand-controller-button-previous`,
              nextEl: `#${randomId} .brand-controller-button-next`,
            }}
            pagination={{
              el: `#${randomId} .brand-controller-pagination`,
              clickable: true,
              bulletElement: "li",
              bulletActiveClass: `brand-controller-pagination-bullet-active`,
              bulletClass: `brand-controller-pagination-bullet bg-${colour.text}`,
            }}
            spaceBetween={32}
            speed={1000}
            onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex + 1)}
          >
            {items &&
              items.map((node, index) => {
                return (
                  <SwiperSlide>
                    <Testimonial node={node && node} theme={colour.text} />
                  </SwiperSlide>
                );
              })}
          </Swiper>
        </div>
        <div className="flex flex-row justify-between md:justify-end items-center gap-5">
          <span className="brand-button aspect-square w-12 p-0 brand-controller-button-previous order-1">
            <span className="material-icons text-4xl brand-icon-start">
              chevron_left
            </span>
          </span>
          <span className="brand-button aspect-square w-12 p-0 brand-controller-button-next order-3 md:order-2">
            <span className="material-icons text-4xl">chevron_right</span>
          </span>
          <Progress
            current={activeIndex && activeIndex}
            total={items && items.length}
            css="font-medium tracking-[4px] uppercase m-0 text-xs md:text-base order-2 md:order-3"
          />
        </div>
      </div>
    </section>
  );
};

export default Testimonials;

Testimonials.defaultProps = {
  blok: null,
};

Testimonials.propTypes = {
  blok: PropTypes.object,
};
